import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { logError } from 'commons/logger';
import PromotionBanner from 'components/consumer/promotion-banner';
import useContentfulPromotionContent from 'hooks/useContentfulPromotionContent';
const isDateLessThan5Days = dateString => {
  if (!dateString) {
    return false;
  }
  try {
    const date = new Date(dateString);
    const now = new Date();
    const difference = date.getTime() - now.getTime();
    if (difference < 5 * 24 * 3600 * 1000 && difference > 0) {
      return true;
    }
  } catch (err) {
    logError(err, 'Error while processing the endDate');
  }
  return false;
};
const PromotionBannerDynamic = () => {
  const $ = _c(13);
  const {
    loading,
    promotionData
  } = useContentfulPromotionContent();
  if (loading) {
    return null;
  }
  let t0;
  if ($[0] !== promotionData) {
    t0 = promotionData || {};
    $[0] = promotionData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    alternateTitle,
    topBannerText,
    endDate,
    topBannerTextColor,
    topBannerBackgroundColor,
    topBannerBackgroundImage,
    secondaryBannerText
  } = t0;
  let t1;
  if ($[2] !== endDate) {
    t1 = isDateLessThan5Days(endDate);
    $[2] = endDate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== alternateTitle || $[5] !== endDate || $[6] !== secondaryBannerText || $[7] !== t1 || $[8] !== topBannerBackgroundColor || $[9] !== topBannerBackgroundImage || $[10] !== topBannerText || $[11] !== topBannerTextColor) {
    const promotion = {
      name: alternateTitle,
      discount: null,
      mainContent: alternateTitle,
      topBannerText,
      subContent: null,
      endDate,
      countDownFormat: "DD HH MM",
      countdownToggle: t1,
      backgroundImage: topBannerBackgroundImage,
      backgroundColor: topBannerBackgroundColor,
      backgroundHeight: "50px",
      secondaryBannerText,
      textColor: topBannerTextColor
    };
    t2 = <PromotionBanner config={promotion} />;
    $[4] = alternateTitle;
    $[5] = endDate;
    $[6] = secondaryBannerText;
    $[7] = t1;
    $[8] = topBannerBackgroundColor;
    $[9] = topBannerBackgroundImage;
    $[10] = topBannerText;
    $[11] = topBannerTextColor;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
export default PromotionBannerDynamic;